
export const setShowVikiMsg = (state, payload) => {
  state.showVikiMsg.show = payload.show;
  state.showVikiMsg.msg = payload.msg;
  state.showVikiMsg.type = payload.type;
  state.showVikiMsg.op = payload.op;
};

export const setBadAttemptToLogIn = (state, payload) => {
  state.badAttemptToLogIn = payload;
};
export const setErrorInfo = (state, payload) => {
  state.errorInfo = payload;
};
export const onAuthSuccess = (state, payload) => {
  state.auth.token = payload.token;
};

export const setProfileData = (state, payload) => {
  state.auth.user.id = payload.id;
  state.auth.user.email = payload.email;
  state.auth.user.first_name = payload.first_name;
  state.auth.user.last_name = payload.last_name;
  state.auth.user.role = payload.role;
  state.auth.user.backup_voip_enable = payload.backup_voip_enable;
  state.auth.user.voip_user = payload.voip_user;
  state.auth.user.backup_voip_user = payload.backup_voip_user;
  state.auth.user.profile_img = payload.profile_img;
  state.auth.user.team_id = payload.team_id;
  state.auth.user.seniority = payload.seniority;
  state.auth.user.user_shifts = payload.user_shifts;
  try { state.auth.user.extra = payload.extra ? JSON.parse(payload.extra) : {}; } catch(e) { state.auth.user.extra = {}; }
};

export const onLogout = (state, payload) => {
  state.auth.token = "";
  //state.auth.user = null;
  state.auth.user.id = null;
  state.auth.user.email = null;
  state.auth.user.first_name = null;
  state.auth.user.last_name = null;
  state.auth.user.role = null;
  state.auth.user.backup_voip_enable = null;
  state.auth.user.voip_user = null;
  state.auth.user.backup_voip_user = null;
  state.auth.user.profile_img = null;
  state.auth.user.team_id = null;
  state.auth.user.socket_session_id = null;
  state.auth.user.seniority = null;
  state.auth.user.user_shifts = [];
  state.auth.user.extra = {};
};
